
import React from 'react';
import { Button } from '@/components/ui/button';
import { FileDown, FileUp, Save } from 'lucide-react';

interface RoleAccessActionsProps {
  isSaving: boolean;
  onSave: () => void;
  onReset: () => void;
  onExport: () => void;
  onImport: () => void;
}

export function RoleAccessActions({
  isSaving,
  onSave,
  onReset,
  onExport,
  onImport
}: RoleAccessActionsProps) {
  return (
    <div className="flex justify-end gap-2 mb-4">
      <Button variant="outline" size="sm" onClick={onReset}>
        Reset to Defaults
      </Button>
      <Button variant="outline" size="sm" onClick={onImport}>
        <FileUp className="h-4 w-4 mr-1" />
        Import
      </Button>
      <Button variant="outline" size="sm" onClick={onExport}>
        <FileDown className="h-4 w-4 mr-1" />
        Export
      </Button>
      <Button size="sm" onClick={onSave} disabled={isSaving}>
        <Save className="h-4 w-4 mr-1" />
        {isSaving ? 'Saving...' : 'Save'}
      </Button>
    </div>
  );
}
